import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider} from 'material-ui-pickers';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl'
import "assets/vendors/style"
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';

import MainApp from 'app/index';
import SignUp from './SignUp';
import SignIn from './SignIn';
import Success from './Success';
import RequestDeleteAccount from './RequestDeleteAccount';
import {getUser, setInitUrl, userSignOut, userSignOutToken, requestDeleteAccount} from '../actions/Auth';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';
import { requestGql } from 'constants/Request';
import jwtDecode from "jwt-decode";

const RestrictedRoute = ({component: Component, token, permission, ...rest}) =>
  <Route
    {...rest}
    render={props =>
      token
        ? permission ?
          <Component {...props} /> : <Redirect
              to={{
                pathname: '/error',
                state: {from: props.location}
              }}
          />
        : <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />}
  />;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasPermission:true
    };
  }

  UNSAFE_componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    let url = '';
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
      console.log("this.props.history.location.pathname ", this.props.history.location.pathname)
      url = this.props.history.location.pathname;
    }else {
      url = this.props.initURL;
    }

    this.checkPermissionForUrl(url);
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.token && (nextProps.userType < 0)) {
      this.props.getUser()

    }
    let url = this.props.history.location.pathname;
    this.checkPermissionForUrl(url);
  }

  // A freshly-issued JWT can take a moment to be recognized backend-side, so a single
  // UNAUTHORIZED right after login doesn't necessarily mean the session is invalid —
  // retry once before forcing a sign-out (avoids the "have to click login 10x" bug).
  checkPermissionForUrl(url, isRetry = false) {
    const query = `
        query checkPermission($url: String){
            checkPermission(url: $url){
                has_permission
                error{
                    code
                    msg
                }
              }
          }
            `;
    requestGql(query, {url})
        .then(result => {
          if(result.checkPermission.error && result.checkPermission.error.code === "UNAUTHORIZED") {
            if(url !== '/logout' && url !== '/signin' && url !== '/signup' && url !== '/success' && url !== '/requestDeleteAccount'){
              if (!isRetry) {
                setTimeout(() => this.checkPermissionForUrl(url, true), 1500);
              } else {
                this.props.userSignOutToken();
                this.props.history.push('/signin');
              }
            }
          }else{
            this.setState({
              hasPermission: result.checkPermission.has_permission
            })
          }
        })
  }
  render() {
    const {match, location, locale, token, initURL, isDirectionRTL} = this.props;
    const {hasPermission} = this.state;
    if (location.pathname === '/') {
      if (token === null) {
        return ( <Redirect to={'/signin'}/> );
      }
      let payload = jwtDecode(token)

      if(payload.role_id === 4){
        return ( <Redirect to={'/logout'}/> );
      }
      if (initURL === '' || initURL === '/' || initURL === '/signin') {
        if(payload.role_id === 3){
          return ( <Redirect to={'/patient/corporate'}/> );
        } else if(payload.role_id === 17){
          return ( <Redirect to={'/waitingRoomManagement'}/> );
        }
        return ( <Redirect to={'/dashboard'}/> );
      } else {
        return ( <Redirect to={initURL}/> );
      }
    }else if(location.pathname === '/logout') {
      this.props.userSignOut();
    }

    const applyTheme = createMuiTheme(defaultTheme);

    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }
    const currentAppLocale = AppLocale[locale.locale];
    return (
      <MuiThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}>
            <RTL>
              <div className="app-main">
                <Switch>
                  <Route path='/requestDeleteAccount' component={RequestDeleteAccount}/>
                  <Route path='/success' component={Success}/>
                  <Route path='/signin' component={SignIn}/>
                  <Route path='/signup' component={SignUp}/>
                  <RestrictedRoute path={`${match.url}`} token={token}
                                   permission={(location.pathname === '/error' || initURL === '/' || location.pathname === '/signin' || hasPermission == null) ? true : hasPermission}
                                   component={MainApp}/>
                  <Route
                    component={asyncComponent(() => import('components/Error404'))}/>
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {sideNavColor, locale, isDirectionRTL} = settings;
  const {userType, token, initURL} = auth;
  return {sideNavColor, token, locale, isDirectionRTL, userType, initURL}
};

export default connect(mapStateToProps, {setInitUrl, getUser, userSignOut, userSignOutToken, requestDeleteAccount})(App);

